import { Calendar } from "primereact/calendar";
import styles from "./DateRangeFilter.module.scss";

const DateRangeFilter = ({ value, onChange }) => {
  const { startDate = null, endDate = null } = value || {};
  return (
    <div className="grid">
      <div className="col-12 md:col-4 xl:col-3 mb-2">
        <div className={styles?.formLabelContainer}>
          <label htmlFor="startDate">
            <span className={styles.formLabel}>Start Date</span>
          </label>
        </div>
        <Calendar
          inputId="startDate"
          value={startDate}
          onChange={(e) => onChange({ startDate: e.value, endDate })}
          maxDate={endDate ?? undefined}
          readOnlyInput
          showIcon
          placeholder="mm-dd-yy"
        />
      </div>

      <div className="col-12 md:col-4 xl:col-3 mb-2">
        <div className={styles?.formLabelContainer}>
          <label htmlFor="endDate">
            <span className={styles.formLabel}>End Date</span>
          </label>
        </div>
        <Calendar
          inputId="endDate"
          value={endDate}
          onChange={(e) => onChange({ startDate, endDate: e.value })}
          minDate={startDate ?? undefined}
          readOnlyInput
          showIcon
          placeholder="mm-dd-yy"
        />
      </div>
    </div>
  );
};

export default DateRangeFilter;
